<template>
   <div class="centerx" id="add-combo">
    <vs-popup class="add-combo-item" title="Choose item:" :active.sync="popupAddItem.isOpen">
      <div>
        <div class="p-6 w-full" style="position: absolute; top: 0; left: 0">
          <div class="con-input-search vs-table--search m-0" style="max-width: unset">
            <input type="text" class="input-search vs-table--search-input rounded-item border-custom w-full py-3 text-sm" @input="searchService" placeholder="Search service...">
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
          </div>
        </div>

        <div style="height: calc(100vh - 365px); overflow-y: auto; margin-top: 80px">
          <div class="px-6 cate-item-content" v-for="(cate, index) in serviceListWithSearch" :key="index" @click="updateCurrentCategory(cate)">
            <div v-if="cate.id && cate.services.length > 0">
              <div class="p-4 px-2 category-content">
                <vs-checkbox class="w-auto" :value="activeCategory[index]" @click="updateCategoryStatus(cate, index)">
                  <h4 class="text-lg font-bold pl-3">{{cate.name}}</h4>
                </vs-checkbox>
              </div>
              <!-- <vs-row vs-w="12">
                <vs-col class="popup-staff-col" v-for="(item, index) in cate.services" :key="index" @click.native="addItemToList(item)">
                  <div id="my-staff-item" class="p-2">
                    <vx-card class="shadow-md staff-item m-2" :style="`background: ${getClass(item) ? cate.color_detail.color_code : '#fff'}; border: 2px solid ${cate.color_detail.color_code}`">
                      <div class="flex align-center">
                        <div
                            class="font-bold text-lg ml-2 overflow-hidden"
                            style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;" :style="`color: ${getClass(item) ? '#fff' : cate.color_detail.color_code}`"
                          >{{item.name}}</div>
                      </div>
                    </vx-card>
                  </div>
                </vs-col>
              </vs-row> -->
              <div class="service-list rounded-item">
                <vs-button
                  type="border"
                  v-for="(item) in cate.services"
                  class="user-select-none"
                  :key="item.id"
                  :class="{'active': isActiveItem(item)}"
                  @click="addItemToList(item)"
                >{{item.name}}</vs-button>
              </div>
            </div>
          </div>

        </div>
        <div class="flex flex-wrap items-center p-6 pb-0 justify-center" slot="footer">
          <vs-button class="mr-6" style="min-width: 140px" @click="confirmList">Confirm</vs-button>
          <vs-button type="border" color="danger" style="min-width: 140px" @click="closePopup">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'popup-add-item',
  props: {
    popupAddItem: {
      type : Object
    },
    listItemAdded: {
      type : Array
    }
  },
  data() {
    let listItem = [];
    if(this.listItemAdded.length > 0) {
      for(let i = 0; i < this.listItemAdded.length; i++) {
        listItem.push(JSON.parse(JSON.stringify(this.listItemAdded[i])));
      }
    }
    return {
      search: "",
      listItem,
      currentCategory: {},
      currentService: {},
      activeCategory: [],
    }
  },
  watch: {
    popupAddItem: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupAddItem.isOpen) {
          this.listItem = [];
          if(this.listItemAdded.length > 0) {
            for(let i = 0; i < this.listItemAdded.length; i++) {
              this.listItem.push(JSON.parse(JSON.stringify(this.listItemAdded[i])));
            }
          }
        }
      }
    },
    serviceListWithSearch: {
      immediate: true,
      deep: true,
      handler() {
        this.updateData();
      }
    },
    listItem: {
      immediate: true,
      deep: true,
      handler() {
        this.updateData();
      }
    }
  },
  methods: {
    updateData() {
      if(this.serviceListWithSearch && this.serviceListWithSearch.length > 0) {
        this.activeCategory = [];
        for(let i = 0; i < this.serviceListWithSearch.length; i++) {
          if(this.checkActiveCategory(this.serviceListWithSearch[i].services)) {
            this.activeCategory.push(true);
          } else {
            this.activeCategory.push(false);
          }
        }
      }
    },
    checkActiveCategory(items) {
      if(items.length == 0) return false;
      for(let i = 0; i < items.length; i++) {
        if(this.isActiveItem(items[i]) == false) {
          return false;
        }
      }
      return true;
    },
    updateCategoryStatus(category, index) {
      if(category) {
        if(this.activeCategory[index]) {
          // this.deleteAllService(category.services, index);
          this.activeCategory[index] = false;
          for(let i = 0; i < this.listItem.length;) {
            if(this.listItem[i].category_id == category.id) {
              this.listItem.splice(i, 1);
            } else {
              i++;
            }
          }
        } else {
          this.activeCategory[index] = true;
          // this.addAllService(category.services, index);
          if(category.services && category.services.length > 0) {
            for(let i = 0; i < category.services.length; i++) {
              if(this.isActiveItem(category.services[i]) == false) {
                this.listItem.push(category.services[i]);
              }
            }
            for(let j = 0; j < this.serviceListWithSearch.length; j++) {
              for(let k = 0; k < this.listItem.length; k++) {
                if(this.serviceListWithSearch[j].id == this.listItem[k].category_id) {
                  this.listItem[k].color_code = this.serviceListWithSearch[j].color_detail.color_code;
                }
              }
            }
          }
        }
      }
    },
    updateCurrentCategory(category) {
      this.currentCategory = category;
    },
    isActiveItem(item) {
      for(let i = 0; i < this.listItem.length; i++) {
        if(item.id == this.listItem[i].id) {
          return true;
        }
      }
      return false;
    },
    searchService({target}) {
      this.search = target.value;
    },
    addItemToList(item) {
      let count = 0;
      if(this.listItem.length > 0) {
        for(let i = 0; i < this.listItem.length; i++) {
          if(this.listItem[i].id == item.id) {
            this.listItem.splice(i, 1);
            count++;
          }
        }
        if(count == 0) {
          this.listItem.push(item);
        }
      } else {
        this.listItem.push(item);
      }
      for(let j = 0; j < this.serviceListWithSearch.length; j++) {
        for(let k = 0; k < this.listItem.length; k++) {
          if(this.serviceListWithSearch[j].id == this.listItem[k].category_id) {
            this.listItem[k].color_code = this.serviceListWithSearch[j].color_detail.color_code;
          }
        }
      }
    },
    confirmList() {
      this.$emit("ConfirmList", this.listItem);
    },
    closePopup() {
      this.$emit("ClosePopup");
    }
  },
  computed: {
    serviceListWithSearch() {
      return this.$store.getters['staffList/serviceListWithSearch'](this.search);
    },
  },
  // created() {
  //   this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100});
  // }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
@import "@/assets/scss/custom/_variables";
.con-vs-popup {
    &.add-combo-item {
        z-index: 999999 !important;
        .vs-popup {
            width: calc(100% - 80px);
            max-width: 900px;
            height: auto;
            .vs-popup--content {
                width: auto;
                height: calc(100vh - 200px);
                position: relative;
                margin: 0 !important;
                padding: 0;

                .cate-item-content {
                  .service-list {
                    // padding: 20px;
                    margin: 15px 0 30px;
                    background: #fff;
                    .vs-button {
                      margin: 10px;
                      .vs-button--text {
                        word-break: break-word;
                      }
                    }
                  }
                  // .vs-checkbox--input {
                  //   width: 20px;
                  // }
  
                  .con-vs-checkbox {
                    width: fit-content !important;
                    .vs-checkbox {
                      background: #fff;
                    }
                  }
  
                  .category-content {
                    background: #F4F4F4;
                    border-radius: 5px;
                  }
                
                  .vs-button--text{
                    // color: $primary !important;
                    color: $dark-blue !important;
                  }
  
                  .vs-button-border {
                    border: 1px solid $dark-blue;
                  }
  
                  .other-category {
                    padding-left: 25px;
                  }
                
                  .active,
                  .all-active {
                    // background: $primary !important;
                    // background: $primary !important;
                    // background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7)) !important;
                    background: $dark-blue !important;
                    // border: none;
                    // color: $primary;
                    .vs-button--text{
                
                      color: #fff !important;
                    }
                    // .vs-button-text{
                    //   color: #fff !important;
                    // }
                    // background: rgb(48, 21, 201) !important;
                    // color: #fff;
                  }
                  .vs-button--background {
                    opacity: 0 !important;
                    display: none !important;
                    // color: $primary;
                  }
                }


                .popup-staff-col {
                    width: calc(100% / 4) !important;
                }
                @media (max-width: 900px) {
                    .popup-staff-col {
                        width: 50% !important;
                    }
                }
                @media (max-width: 600px) {
                    .popup-staff-col {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}

.border-card{
  border: 2px solid black;
}
</style>
